var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView',{attrs:{"id":"app-content"}}),_c('PortalTarget',{staticClass:"print-wrapper",attrs:{"name":"in-app","multiple":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }